<div class="user-message-container">
    <div class="user-message-content">
        <app-markdown [rawMarkdown]="message.content"></app-markdown>
    </div>
  <app-source-display *ngIf="message.widgetName" [source]="'Widget'" [name]="message.widgetName"></app-source-display>
</div>
